module.exports = __webpack_public_path__ + "static/media/number_of_installments.50fa1216.svg";